import util from "../util";

let controller = "VersaoAppFrontEnd";
export default Object.assign({}, util.GetCrud(controller, null), {})